import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    FETCH_LEAD_YEAR
    FETCH_LEAD_YEAR_SUCCESS
    FETCH_LEAD_YEAR_FAILURE
    SET_IS_YEAR_LOADING
`,
    {
        prefix: "leadyears/"
    }
);
